export interface ImageItem {
  url: string
  title: string
}

interface BentoItemProps {
  image: ImageItem
  onClick: () => void
  className: string
}

const BentoItem = ({ image, onClick, className }: BentoItemProps) => {
  return (
    <div
      className={`group relative overflow-hidden rounded-3xl cursor-pointer shadow-xl hover:shadow-2xl transition-all duration-500 ${className}`}
      onClick={onClick}
    >
      <img
        src={image.url}
        alt={image.title}
        className="w-full h-full object-cover will-change-transform transition-transform duration-700 group-hover:scale-110"
        loading="lazy"
      />

      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <div className="absolute bottom-0 left-0 right-0 p-6">
          <p className="text-white/80">Klikni za uvećanje</p>
        </div>
      </div>
    </div>
  )
}

export default BentoItem;